import {useDispatch, useSelector} from "react-redux";
import * as Crypto from "../Utils/Crypto";
import Moment from 'moment'
import {AuthActions} from "../Redux/Reducers/auth";

function useLoginHook() {
	const  dispatch = useDispatch();
	let {auth} = useSelector((state => ({auth: {
			authenticated: state.auth.authenticated
		}})));
	return {
		...auth,
		onLogin:data=>{
			Crypto.set('token', data.access_token);
			Crypto.set('refresh_token', data.refresh_token);
			Crypto.set("dice-last", Moment().valueOf())
			Crypto.set("dice-name",data.name)
			Crypto.set("dice-login-in", "yes");
			dispatch({
				type: AuthActions.Login,
				data: {
					name: data.name,
					login: Moment()
				}
			})
		},
		reloadConfig:()=>{

		}
	}
}


export {
	useLoginHook
}
